var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('config-item',{attrs:{"label":_vm.label}},[_c('GoodsConfigList',{attrs:{"value":_vm.mValue},on:{"edit":_vm.edit,"submit":_vm.replace}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }